import { useEffect, useState } from 'react'

// Returns a debounced copy of `value` that only updates after `delay` ms of
// quiet. Handy for search inputs so we don't fetch on every keystroke.
export default function useDebounced(value, delay = 200) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}
